var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShirt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 39,
    viewBox: "0 0 45 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.37598 37.3586C8.37598 37.9058 8.81952 38.3493 9.36666 38.3493H35.6335C36.1807 38.3493 36.6242 37.9058 36.6242 37.3586V33.4639H8.37598V37.3586Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0093 0.651367C41.1206 0.651367 32.8641 0.651367 30.0572 0.651367C29.5626 0.651367 29.1458 1.01508 29.0774 1.5049C28.621 4.7672 25.6067 7.28828 22.5 7.28828C19.3932 7.28828 16.3788 4.7672 15.9225 1.5049C15.8542 1.01606 15.4362 0.651367 14.9427 0.651367C12.161 0.651367 3.96958 0.651367 0.990683 0.651367C0.443542 0.651367 0 1.09481 0 1.64186V12.3024C0 12.8495 0.443542 13.293 0.990683 13.293H8.37585V30.6272H36.6241V13.293H44.0093C44.5565 13.293 45 12.8495 45 12.3024V1.64205C44.9999 1.09491 44.5565 0.651367 44.0093 0.651367Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShirt);
export default __webpack_public_path__ + "static/media/shirt.cf59944bc31f8b7406c75e3c16f22dd9.svg";
export { ForwardRef as ReactComponent };